import React from 'react';
import { COLORS } from '@constants';
import { Typography } from '@ui';
import { StyledFlex } from './styled';

const NoProductsFound = () => {
    return (
        <StyledFlex gap={8} vertical align='center' justify='center' data-e2e='products_no-products-found_section'>
            <Typography.Title level={2} color={COLORS.$gray60Black} data-e2e='products_no-products-found_title'>
                No products found
            </Typography.Title>
            <Typography.Text
                type='descriptor1'
                color={COLORS.$gray60Black}
                data-e2e='products_no-products-found_description'
            >
                We couldn’t find any products matching your search
            </Typography.Text>
        </StyledFlex>
    );
};

export default NoProductsFound;
